import { render, staticRenderFns } from "./SimpleTextRenderer.vue?vue&type=template&id=bb1297cc&scoped=true"
import script from "./SimpleTextRenderer.vue?vue&type=script&lang=js"
export * from "./SimpleTextRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1297cc",
  null
  
)

export default component.exports